import { useIncognitoStore } from '@/stores/incognitoStore'
import {
  obfuscateUUID,
  obfuscatePoolName,
  obfuscateAccountName,
  obfuscateTags,
  obfuscateEmail,
  obfuscateUserName,
} from '@/lib/incognito'

export interface UseIncognito {
  isIncognito: boolean
  toggle: () => void
  /** Obfuscate a pool name */
  poolName: (real: string) => string
  /** Obfuscate an account name into a fake company name */
  accountName: (real: string) => string
  /** Obfuscate any UUID (pool ID, system ID, task ID, account ID, …) */
  uuid: (real: string) => string
  /** Obfuscate a tags object */
  tags: (real: Record<string, string>) => Record<string, string>
  /** Obfuscate an email address */
  email: (real: string) => string
  /** Obfuscate a display name */
  userName: (real: string) => string
}

export function useIncognito(): UseIncognito {
  const { isIncognito, toggle } = useIncognitoStore()

  return {
    isIncognito,
    toggle,
    poolName: (real) => (isIncognito ? obfuscatePoolName(real) : real),
    accountName: (real) => (isIncognito ? obfuscateAccountName(real) : real),
    uuid: (real) => (isIncognito ? obfuscateUUID(real) : real),
    tags: (real) => (isIncognito ? obfuscateTags(real) : real),
    email: (real) => (isIncognito ? obfuscateEmail(real) : real),
    userName: (real) => (isIncognito ? obfuscateUserName(real) : real),
  }
}
